export default {
  
  ERROR: {
    EMPTY: {
      ASSET          : "Asset is Empty!",
      MAINTENANCE    : "Maintenance is Empty!",
      SCHEDULE_START : "Schedule start is Empty!",
      SCHEDULE_END   : "Schedule end is Empty!",
      REPEAT_PERIOD  : "Repeat period is Empty or must be greater then 0!",
      REMINDER       : "Reminder is Empty!",
      DESCRIPTION    : "Description is Empty!",
      REPORT_TYPE    : "Report type is Empty!",
      EMAIL          : "Email is Empty!",
      REMAINDER_TIME : "Remainder time is Empty!",
      PHONE_NUMBER   : "Phone number is Empty!",
      CONTRACTOR     : "Contractor is Empty!",
      AMOUNT         : "Amount is Empty!",
      REMINDER_LIST  : "Reminder List is Empty!",
    },
    LOAD: {
      DATA : "Failed load data",
    },
    INVALID : {
      AMOUNT : "Amount is Invalid!",
      FILE_TYPE : "Uploaded File Type is Invalid!"
    }
  }, 

  SUCCESS: {
    REGISTRATION : "Successfully added",
    UPDATE       : "Successfully updated",
    DELETE       : "Successfully deleted",
  },

  PERMISSION: {
    DONT_HAVE_ACCESS : "You don't have access to perform this action"
  },

}


// WEBPACK FOOTER //
// ./src/App/config/message_v2.js